import { rem } from "polished";
import React from "react";
import styled from "styled-components";
import Button, { ButtonWrapper } from "../../../../Button";

const ItemDetails = ({ item, onModalClose }) => {
  const {
    label,
    image,
    price,
    unit,
    maxtjocklek,
    mintjocklek,
    width,
    height,
    breadth,
    length,
    skapstorlek,
    content,
    ptype,
  } = item;

  const dimension =
    width && height
      ? [width, height]
      : length && breadth
      ? [length, breadth]
      : [];

  return (
    <Layout className="builder-element">
      <div className="texture-details">
        <div className="image">
          <img src={image} alt={label} />
        </div>
        {ptype === 'disklador' ? 
        <div dangerouslySetInnerHTML={{ __html: content }} className="information"/> : 
        <>
          <div className="title">
            <h2>{label}</h2>
          </div>
          <div className="details">
            {dimension && dimension.length ? (
              <p>
                Dimensioner:
                {dimension.join(" X ")} mm
              </p>
            ) : null}
            <p>Pris: {[price, unit].join(" ")}</p>
            {maxtjocklek ? <p>Max tjocklek: {maxtjocklek}</p> : null}
            {mintjocklek ? <p>Min tjocklek: {mintjocklek}</p> : null}
            {skapstorlek ? <p>Skåpstorlek: {skapstorlek} mm</p> : null}
          </div>
        </>}
        
        <ButtonWrapper>
          <Button onClick={onModalClose}>Stäng</Button>
        </ButtonWrapper>
      </div>
    </Layout>
  );
};
export default ItemDetails;

const Layout = styled.div`
  .texture-details {
    padding: ${rem(30)} 0;

    .information {
      margin: 20px 0;
      h1,h2,h3,h4,h5,h6,img,p {
        margin-top: 20px;
        line-height: normal;
      }

      h1 {
        font-size: 30px;
      }
      h2 {
        font-size: 24px;
      }

      h3 {
        font-size: 22px;
      }

      h4 {
        font-size: 20px;
      }

      h5 {
        font-size: 18px;
      }

      h6{
        font-size: 16px;
      }
      img {
        display: block;
      }
    }

    .image {
      margin-bottom: ${rem(20)};

      img {
        max-height: 200px;
      }
    }

    .title {
      margin-bottom: ${rem(10)};
      h2 {
        margin-bottom: 0;
      }
    }

    .details {
      p {
        margin: 0;

        + p {
          margin-top: ${rem(10)};
        }
      }
    }

    .builder-button {
      max-width: 150px;
    }
  }
`;
